import { Injectable, inject } from '@angular/core';
import Session from '../utils/session.service';
import FetchingService from '../services/fetching.service';
import AngularHelperService from '../services/angular-helper.service';

@Injectable({ providedIn: 'root' })
export default class WordCloudService {
	private session: Session = inject(Session);
	private fetchingService: FetchingService = inject(FetchingService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	getQuestionnaire() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var user: any = this.session.getSession().user || {};
		this.fetchingService.get('QUESTIONNAIRE', {
			params: { language: user.deviceLanguage || 'et_EE', code: 'WORD-CLOUD' }
		}).then((response) => {
			deferred.resolve(response);
		}).catch(() => {
			deferred.reject();
		});
		return deferred.promise;
	}
	
}